// extracted by mini-css-extract-plugin
module.exports = {"unreadMessagesWrapper":"MessagesCount_unreadMessagesWrapper__hKTVv","unreadMessages":"MessagesCount_unreadMessages__1vUyQ"};